import * as types from '../types';

export const fetchMenuRequest = (language = 'hindi') => ({ type: types.FETCH_MENU_REQUEST, language });
export const fetchMenuSuccess = (menu) => ({ type: types.FETCH_MENU_SUCCESS, payload: menu });
export const fetchMenuFailure = (error) => ({ type: types.FETCH_MENU_FAILURE, payload: error });
export const clearMenu = () => ({ type: types.CLEAR_MENU });
